import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';

const StatTile = ({ label, value, accent = 'brand.500', icon }) => (
  <Box
    bg="white"
    borderRadius="xl"
    border="1px solid"
    borderColor="slate.100"
    p={4}
    boxShadow="soft"
    position="relative"
    overflow="hidden"
    _before={{
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      w: '3px',
      h: 'full',
      bg: accent,
    }}
  >
    <Flex justify="space-between" align="flex-start">
      <Box>
        <Text fontSize="xs" fontWeight="600" color="slate.500" textTransform="uppercase" letterSpacing="0.06em">
          {label}
        </Text>
        <Text mt={1} fontSize="2xl" fontWeight="700" color="slate.800" fontFamily="heading">
          {value}
        </Text>
      </Box>
      {icon && (
        <Flex
          align="center"
          justify="center"
          w={10}
          h={10}
          borderRadius="lg"
          bg={`${accent.split('.')[0]}.50`}
          color={accent}
          fontSize="lg"
        >
          {icon}
        </Flex>
      )}
    </Flex>
  </Box>
);

export default StatTile;
